import { Link } from "react-router-dom";

const QUICK_LINKS = [
  { label: "电影频道", path: "/movie" },
  { label: "电视剧频道", path: "/tv" },
  { label: "影视资讯", path: "/news" },
  { label: "搜索内容", path: "/search" },
];

const GENRE_LINKS = ["科幻", "悬疑", "古装", "喜剧", "动作", "剧情"];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto grid grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="mb-3 flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
              <i className="ri-film-line text-lg" />
            </span>
            <span className="font-heading text-lg font-bold text-background-50">飘花电影网</span>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-background-200/80">
            飘花电影网专注于提供最新电影和电视剧的在线播放资源与影视资讯，涵盖多类型影视作品，方便影视爱好者快速找到感兴趣的内容并了解行业动态。
          </p>
          <div className="mt-4 flex items-center gap-3 text-background-200/70">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-800">
              <i className="ri-wechat-line" />
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-800">
              <i className="ri-weibo-line" />
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-800">
              <i className="ri-mail-line" />
            </span>
          </div>
        </div>

        <div>
          <h4 className="mb-3 font-heading text-sm font-semibold text-background-50">快捷入口</h4>
          <ul className="space-y-2 text-sm">
            {QUICK_LINKS.map((item) => (
              <li key={item.path}>
                <Link to={item.path} className="text-background-200/80 transition-colors hover:text-accent-400">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-3 font-heading text-sm font-semibold text-background-50">热门类型</h4>
          <div className="flex flex-wrap gap-2">
            {GENRE_LINKS.map((genre) => (
              <Link
                key={genre}
                to={`/search?q=${encodeURIComponent(genre)}`}
                className="rounded-full bg-primary-800 px-3 py-1 text-xs text-background-200/90 transition-colors hover:bg-accent-500 hover:text-primary-950"
              >
                {genre}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-300/70 md:flex-row md:px-6">
          <p>© 2026 飘花电影网 · 本站为影视内容演示站点，所有资源仅作展示用途</p>
          <p>影视资讯 · 内容推荐 · 资源共享</p>
        </div>
      </div>
    </footer>
  );
}